export enum FatigueType {
  flexible = 'FLEXIBLE',
  rigid = 'RIGID',
}
